import { Component, inject, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular/lazy';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';
import { Autocomplete } from '../../models/autocomplete.model';

@Component({
    selector: 'web-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    imports: [IonicModule],
})
export class InputComponent extends AbstractComponentMobile implements ControlValueAccessor {
    protected controlDir = inject(NgControl, { self: true, optional: true });

    sanitizer = inject(DomSanitizer);

    public override tag = '[InputComponent]';

    @Input()
    public type: 'text' | 'password' | 'email' = 'text';

    @Input()
    public placeholder = '';

    @Input()
    public value: string | number = '';

    @Input()
    public autocompleteValues: Autocomplete[] = [];
    suggestionSelected = false;

    @Input()
    public title?: string;

    @Input()
    public helperText?: string;

    @Input()
    public helperTextClass?: string = 'footnote-regular';

    @Input()
    public disabled?: boolean = false;

    @Input()
    public icon?: string;

    @Input()
    public iconPosition?: 'start' | 'end' = 'start';

    @Input()
    public inputmode?: string;

    @Input()
    public error?: string | null;

    @Input()
    public checkDirty = true;

    public passwordIcon = false;

    constructor() {
        super();
        const controlDir = this.controlDir;

        if (controlDir) {
            controlDir.valueAccessor = this;
        }
    }

    togglePassword(): void {
        if (this.type === 'password') {
            this.passwordIcon = true;
            this.type = 'text';
        } else {
            this.type = 'password';
            this.passwordIcon = false;
        }
    }

    writeValue(value: string): void {
        this.value = value;
    }

    onInputChanged(event: Event) {
        const input = (event.target as HTMLInputElement).value;
        this.value = input;
        this.onChange(input);
        this.suggestionSelected = false;
    }

    selectAutcompleteValue(value: Autocomplete) {
        this.suggestionSelected = true;
        this.value = value.value;
        this.onChange(value.value);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    onChange = (_: string | number) => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onTouched = () => {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
        // disable other components here
    }
}
